/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CheckoutOrderOut } from '../models/CheckoutOrderOut';
import type { PaymentOut } from '../models/PaymentOut';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class PaymentsService {
    /**
     * Checkout
     * @returns CheckoutOrderOut Successful Response
     * @throws ApiError
     */
    public static checkoutPaymentsCheckoutOrderGet(): CancelablePromise<Array<CheckoutOrderOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payments/checkout_order',
        });
    }
    /**
     * Checkout
     * Checkout endpoint supporting:
     * - FULL payment
     * - PARTIAL payment
     * - INSTALLMENT payment
     * @param serviceRequestId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static checkoutPaymentsCheckoutServiceRequestIdPost(
        serviceRequestId: number,
        requestBody?: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payments/checkout/{service_request_id}',
            path: {
                'service_request_id': serviceRequestId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payments
     * @param status
     * @returns PaymentOut Successful Response
     * @throws ApiError
     */
    public static getPaymentsPaymentsRecordsGet(
        status?: (string | null),
    ): CancelablePromise<Array<PaymentOut>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payments/records',
            query: {
                'status': status,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Payment Summary
     * @param serviceRequestId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getPaymentSummaryPaymentsSummaryServiceRequestIdGet(
        serviceRequestId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/payments/summary/{service_request_id}',
            path: {
                'service_request_id': serviceRequestId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Razorpay Payment Webhook
     * @returns any Successful Response
     * @throws ApiError
     */
    public static razorpayPaymentWebhookPaymentsWebhookRazorpayPost(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payments/webhook/razorpay',
        });
    }
    /**
     * Verify Payment
     * Razorpay Payment Verification
     *
     * Guarantees:
     * - Never loses transaction_id
     * - Moves uncertain states → PROCESSING
     * - Idempotent
     * - Updates Order + Quote safely
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static verifyPaymentPaymentsVerifyPost(
        requestBody: Record<string, any>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/payments/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
